import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {Auth} from 'aws-amplify';

const initialState = {
  currentUser: null,
  id: null,
  status: {signOut: 'idle', signIn: 'idle'},
  message: null
}

export const fetchUser = createAsyncThunk(
  'user/fetchUser',
  async () => {
    return await Auth.currentAuthenticatedUser()
  }
)

export const signInUser = createAsyncThunk(
  'user/signInUser',
  async (userData) => {
    const {username, password} = userData
    return await Auth.signIn(username, password)
  }
)

export const signOutUser = createAsyncThunk(
  'user/signOutUser',
  async () => {
    await Auth.signOut()
  }
)

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    userSet(state, action) {
      state.currentUser = action.payload
    },
    userMessageClear(state) {
      state.message = null
    }
  },
  extraReducers(builder) {
    builder
      .addCase(signInUser.fulfilled, (state, action) => {
        state.currentUser = {username: action.payload.username, id: action.payload.attributes.sub }
        state.status.signOut = 'idle'
        state.status.signIn = 'fulfilled'
        state.message = null
      })
      .addCase(signInUser.pending, (state) => {
        state.status.signIn = 'pending'
      })
      .addCase(signInUser.rejected, (state, action) => {
        state.message = `Error logging in: ${action.error.message}`
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.currentUser = {username: action.payload.username, id: action.payload.attributes.sub }
        state.status.signOut = 'idle'
        state.status.signIn = 'fulfilled'
        state.message = null
      })
      .addCase(signOutUser.pending, (state) => {
        state.status.signOut = 'pending'
      })
      .addCase(signOutUser.fulfilled, (state) => {
        state.currentUser = null
        state.status.signOut = 'fulfilled'
        state.status.signIn = 'idle'
        state.message = null
      })
  }
})

export const { userSet, userMessageClear } = userSlice.actions

export default userSlice.reducer

export const selectCurrentUser = state => state.user.currentUser

export const selectMessage = state => state.user.message
